import VendorList from 'features/vendors/vendor-list-container/vendor-list'
import { getPendingVendors } from 'features/vendors/vendorList.service'
import { resetState, setPendingVendorsSearch } from 'features/vendors/vendorList.slice'
import { type ListVendor } from 'features/vendors/vendorList.types'
import React, { type ReactElement, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'store/hooks'

import styles from './VendorRequests.module.scss'

const VendorRequests: React.FC = (): ReactElement => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(resetState())
    }
  }, [])

  const openVendorProfile = (vendor: ListVendor): void => {
    navigate(`/vendor/${vendor.id}`)
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>Dobrodošli na stranicu ZAHTEVI ZA VERIFIKACIJU</div>
        <div className={styles.subtitle}>
          Ovde možete videti listu svih vendora koji čekaju na verifikaciju.
        </div>
      </div>
      <div className={styles.vendorListContainer}>
        <VendorList
          listName="pendingVendorList"
          countName="pendingCount"
          statusName="getPendingVendorListStatus"
          searchName="pendingSearch"
          pageName="pendingPage"
          loadPageAction={getPendingVendors}
          setSearchAction={setPendingVendorsSearch}
          actionButtonText="Verifikuj"
          actionButtonHandler={openVendorProfile}
        />
      </div>
    </div>
  )
}

export default VendorRequests
